import { useLanguageData } from '@/common/hooks/useLanguageData';
import { formatTranslation } from '@/common/utils/formatTranslation';
import {
	IMAGE_GENERATION_SECONDS,
	PORTRAIT_GENERATION_SECONDS,
	VIDEO_GENERATION_SECONDS,
} from '@/common/constants/generationEstimates';
import useGenerationCountdown from '@/common/hooks/useGenerationCountdown';
import {
	ChatMediaFrame,
	ChatMediaMessageWrap,
	ChatMediaOverlay,
	ChatMediaOverlayCopy,
	ChatMediaOverlayMeta,
	ChatMediaOverlayTitle,
	ChatMediaProgressBar,
	ChatMediaProgressTrack,
	ChatMediaSpinner,
} from '../../chatMedia/chatMedia.styles';

const GenerationLoading = ({
	labelKey,
	estimateKey,
	totalDuration = PORTRAIT_GENERATION_SECONDS,
}) => {
	const t = useLanguageData('chat');
	const remainingTime = useGenerationCountdown(totalDuration, true);

	return (
		<ChatMediaMessageWrap>
			<ChatMediaFrame role="status" aria-live="polite">
				<ChatMediaOverlay>
					<ChatMediaSpinner aria-hidden="true" />
					<ChatMediaOverlayCopy>
						<ChatMediaOverlayTitle>{t[labelKey]}</ChatMediaOverlayTitle>
						{estimateKey ? (
							<ChatMediaOverlayMeta>
								{formatTranslation(t[estimateKey], {
									seconds: remainingTime,
								})}
							</ChatMediaOverlayMeta>
						) : null}
					</ChatMediaOverlayCopy>
				</ChatMediaOverlay>
				<ChatMediaProgressTrack aria-hidden="true">
					<ChatMediaProgressBar $duration={totalDuration} />
				</ChatMediaProgressTrack>
			</ChatMediaFrame>
		</ChatMediaMessageWrap>
	);
};

export default GenerationLoading;
